<template>
  <el-dialog
    title="车辆结算"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="900px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="form"
      status-icon
      :rules="rules"
      ref="form"
      label-position="right"
      label-width="100px"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="入场编号" prop="RegistrationNum">
            <div class="text">{{ form.RegistrationNum | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车牌号" prop="LicensePlate">
            <div class="text">{{ form.LicensePlate | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆类型" prop="VehicleType">
            <div class="text">{{ form.VehicleType | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收车时间" prop="RegistrationDate">
            <div class="text">{{ form.RegistrationDate | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="毛重（kg）" prop="GrossWeight">
            <div class="text">{{ form.GrossWeight | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="皮重（kg）" prop="TareWeight">
            <div class="text">{{ form.TareWeight | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="净重（kg）" prop="CarWeigh">
            <div class="text">{{ form.CarWeigh | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="扣杂（kg）" prop="BuckleWeight">
            <div class="text">{{ form.BuckleWeight | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="铝圈个数" prop="AluminumRingNum">
            <div class="text">{{ form.AluminumRingNum | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="送达方式" prop="DeliveryMethod">
            <div class="text">{{ form.DeliveryMethod | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="扣杂费用" prop="MiscellaneousExpenses">
            <el-input
              v-model="form.MiscellaneousExpenses"
              placeholder="扣杂费用"
              @input="calculateSum"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="附加费用" prop="Surcharge">
            <el-input
              v-model="form.Surcharge"
              placeholder="附加费用"
              @input="calculateSum"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单价" prop="UnitPrice">
            <el-input
              v-model="form.UnitPrice"
              placeholder="单价（元/kg）"
              @input="calculateSum"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="结算价" prop="SettlementPrice">
            <el-input
              v-model="form.SettlementPrice"
              placeholder="结算价（元）"
              @input="calculatePrice"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 按钮 -->
    <span slot="footer">
      <el-button type="primary" :loading="loading" @click="save"
        >保 存</el-button
      >
      <el-button type="canale" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      visible: false,
      loading: false,
      form: {},
      rules: {
        MiscellaneousExpenses: [
          {
            required: true,
            message: "不可为空",
          },
          this.$g.validFloat2,
        ],
        Surcharge: [
          {
            required: true,
            message: "不可为空",
          },
          this.$g.validFloat2,
        ],
        UnitPrice: [
          {
            required: true,
            message: "不可为空",
          },
          this.$g.validFloat2,
        ],
        SettlementPrice: [
          {
            required: true,
            message: "不可为空",
          },
          this.$g.validFloat2,
        ],
      },
    };
  },
  watch: {
    item: {
      handler: function (v) {
        this.$get("VehicleRegistration/GetSettlementModel", {
          RegistId: v.KeyId,
        }).then((r) => {
          this.init({ ...r.Result });
        });
        this.activeNames = "1";
        this.visible = true;
      },
    },
  },
  // methods方法
  methods: {
    init(form) {
      this.form = { ...form };
      console.log("信息", this.form);
      if (!this.form.Surcharge) {
        this.form.Surcharge = "0";
      }
      if (!this.form.MiscellaneousExpenses) {
        this.form.MiscellaneousExpenses = "0";
      }
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    },
    calculatePrice() {
      // 确保所有数值都是数字类型，避免字符串拼接
      const sumPrice = Number(this.form.SettlementPrice) || 0;
      const carWeigh = Number(this.form.CarWeigh) || 0;
      const miscellaneousExpenses =
        Number(this.form.MiscellaneousExpenses) || 0;
      const surcharge = Number(this.form.Surcharge) || 0;

      // 计算总价 = 单价 * 净重 - 扣杂费用 + 附加费用
      const unitPrice =
        (sumPrice + miscellaneousExpenses - surcharge) / (carWeigh * 1.0);

      // 保留两位小数并赋值给结算价
      this.form.UnitPrice = unitPrice.toFixed(2);
    },
    //计算总价
    calculateSum() {
      // 确保所有数值都是数字类型，避免字符串拼接
      const unitPrice = Number(this.form.UnitPrice) || 0;
      const carWeigh = Number(this.form.CarWeigh) || 0;
      const miscellaneousExpenses =
        Number(this.form.MiscellaneousExpenses) || 0;
      const surcharge = Number(this.form.Surcharge) || 0;

      // 计算总价 = 单价 * 净重 - 扣杂费用 + 附加费用
      const total = unitPrice * carWeigh - miscellaneousExpenses + surcharge;

      // 保留两位小数并赋值给结算价
      this.form.SettlementPrice = total.toFixed(2);
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return;
        }

        let params = { ...this.form };
        this.loading = true;
        this.$post("VehicleRegistration/AddSettlement", params).then((r) => {
          this.$message.success("添加成功");
          this.visible = false;
          this.$emit("success");
        });
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
